import { DateInt12, DictionaryObject, getDate12AsObject, isset } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { Comment } from './comment.model';
import { Partner } from './partner.model';
import { Place } from './place.model';
import { ProfileReport } from './report.model';
import { User } from './user.model';
import { Activity } from './activity.model';
import { CwtModel } from '@shared/modules/crud';

export enum EventType {
    User = 'user',
    Camping = 'camping'
}

export enum EventPrivacy {
    Public = 'public',
    Private = 'katchOnly'
}

@CwtModel({ name: 'event', path: '/event' })
export class Event extends ApiData {
    partner?: Partner;
    activity?: Activity; // TODO ACTIVITY MODEL
    owner?: User;
    place?: Place;
    startDate?: DateInt12;
    endDate?: DateInt12;
    description?: string;
    type?: EventType;
    capacity?: number;
    host?: User;
    xPos?: number;
    yPos?: number;
    placeDescription?: DictionaryObject;
    privacy?: EventPrivacy;
    isSponsored?: boolean;
    reservationCount?: number;
    reservationDelay?: number;
    maxSimultaneousReservations?: number;
    hostComments?: Comment[];

    public startDateAsObject?: Date;
    public endDateAsObject?: Date;

    constructor(json: any) {
        super(json);
        if (this.startDate) this.startDateAsObject = getDate12AsObject(this.startDate);
        if (this.endDate) this.endDateAsObject = getDate12AsObject(this.endDate);
    }

    fieldDictionary() {
        return {
            partner: Partner,
            place: Place,
            owner: User,
            host: User,
            hostComments: [Comment],
            reports: [ProfileReport],
        };
    }


}
